<template>
    <el-button plain class="is-link tabMore">
        更多
        <el-icon :class="{iaActive: isActive}"><ArrowDown /></el-icon>
    </el-button>
</template>

<script>
export default {
    data() {
        return {
            isActive: false
        }
    },
}
</script>

<style scoped>
    .iaActive{
        transform: rotate(180deg);
    }
</style>